export default __webpack_public_path__ + "static/media/286.1ce8f983.png";